
(function () {
  var TZ = 'Europe/London';

  // Milliseconds until the next 00:00 in the target timezone
  function nextTZMidnight(tz) {
    var now = new Date();
    // "TZ trick": make Date objects with the same wall time in the target tz,
    // then take the difference—works across DST changes.
    var tzNow = new Date(now.toLocaleString('en-US', { timeZone: tz }));
    var tzTomorrow = new Date(tzNow);
    tzTomorrow.setDate(tzNow.getDate() + 1);
    tzTomorrow.setHours(0, 0, 0, 0);
    var diff = tzTomorrow - tzNow; // real ms until next midnight in tz
    return now.getTime() + diff;
  }

  var el = document.getElementById('advent-countdown');
  if (!el) return;

  function tick() {
    var diff = Math.max(0, nextTZMidnight(TZ) - Date.now());
    var h = Math.floor(diff / 36e5);
    var m = Math.floor((diff % 36e5) / 6e4);
    var s = Math.floor((diff % 6e4) / 1000);
    el.textContent =
      String(h).padStart(2, '0') + ':' +
      String(m).padStart(2, '0') + ':' +
      String(s).padStart(2, '0');
  }

  tick();
  setInterval(tick, 1000);
})();

